<template>
  <div
    :style="{
      margin: isWideScreen ? '10%' : '0%',
      'margin-top': isWideScreen ? '25px' : '0px',
    }"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title" v-if="txtList.length > 0">
          {{ txtList[0] }}
        </span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text"
          >操作按钮</el-button
        > -->
      </div>
      <div>
        <span v-for="(txt, index) in txtList" :key="index">
          <h3 v-if="index > 0 && issubTitle(txt)" class="subtitle">
            {{ txt }}
          </h3>
          <p v-else-if="index > 0 && isValidsubTitle(txt)">
            <template v-for="(seg, i) in parseLine(txt)">
              <a
                v-if="seg.isLink"
                :key="'link-' + i"
                :href="seg.text"
                target="_blank"
                rel="noopener noreferrer"
                class="link"
                >{{ seg.text }}</a
              >
              <span v-else :key="'text-' + i">{{ seg.text }}</span>
            </template>
          </p>
        </span>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Card } from "element-ui";

const base64 = require("base-64");
export default {
  name: "privacy",
  components: {
    ElCard : Card
  },
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    txt() {
      return require("../components/" + this.$t("privacy"));
    },
    txtList() {
      const base64String = this.txt.split("base64,")[1];
      const buffer = Buffer.from(base64String, "base64");
      const decodedString = buffer.toString("utf-8");

      return decodedString.split("\n");
    },
  },
  methods: {
    // 把一行文本按 URL 切分为 [普通文本 | 链接] 片段，用于渲染可点击链接
    parseLine(text) {
      const re = /(https?:\/\/[^\s、，。）】"']+)/g;
      const parts = [];
      let last = 0;
      let m;
      while ((m = re.exec(text)) !== null) {
        if (m.index > last) {
          parts.push({ text: text.slice(last, m.index), isLink: false });
        }
        parts.push({ text: m[0], isLink: true });
        last = m.index + m[0].length;
      }
      if (last < text.length) {
        parts.push({ text: text.slice(last), isLink: false });
      }
      return parts.length ? parts : [{ text, isLink: false }];
    },
    issubTitle(txt) {
      return (
        (txt.length > 0 && txt.indexOf("、") > 0 && txt.indexOf("、") < 3) ||
        (txt.indexOf(".") > 0 && txt.indexOf(".") < 3)
      );
    },
    isValidsubTitle(txt) {
      return txt.length > 0;
    },
  },
};
</script>

<style>
/* 正文中自动识别的超链接样式 */
.link {
  color: #409eff;
  text-decoration: underline;
  word-break: break-all;
}
/* 自定义小标题的样式 */
.subtitle {
  font-size: 1.3rem; /* 设置小标题的字号 */
  font-weight: bold; /* 可选的，设置字体为粗体 */
  margin-bottom: 16px; /* 可选的，设置小标题下方的间距 */
}
.box-card {
  text-align: left;
}
.box-card .title {
  font-size: 1.5rem; /* 设置小标题的字号 */
  font-weight: bold; /* 可选的，设置字体为粗体 */
}
</style>


// WEBPACK FOOTER //
// src/views/privacy.vue